module.exports = __webpack_public_path__ + "static/media/22713143_1629550690453449_584066732220936626_o.5319072d.jpg";